import React from 'react'
import { FormattedMessage } from 'react-intl'

const I18n = ({ data, ...rest }) => <FormattedMessage {...data} values={rest} />

export default I18n
